import { useDebounce } from '@chiroup/hooks/useDebounce';
import { useState } from 'react';
import { QueryFunctionContext, useInfiniteQuery } from 'react-query';
import { ResearchFilterQueries } from '../components/research/ResearchList';
import researchService from '../services/research/research.service';

const getQuery = () => {
  return async (context: QueryFunctionContext) => {
    const searchTerm = context.queryKey[1] as Partial<ResearchFilterQueries>;
    const filters: Partial<ResearchFilterQueries> = searchTerm || {};

    return researchService.list({ skip: context.pageParam, filters });
  };
};

const useResearchList = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const debouncedSearch = useDebounce(searchQuery);
  const {
    status,
    data,
    error,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  } = useInfiniteQuery<{ data: any[]; skip: number }>(['research', debouncedSearch], getQuery(), {
    getNextPageParam: lastGroup => lastGroup?.skip || undefined,
    refetchOnWindowFocus: false,
  });

  const onSearch = (params: any) => {
    setSearchQuery(params);
  };

  return {
    status,
    data,
    error,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
    onSearch,
  };
};

export default useResearchList;
